<template>
  <div class="Side5">
    <div class="S5-inner">
      <div class="S5-title">ON STYLE LIVE 입점절차</div>
      <div class="S5-chart">
        <div class="S5-chart-cont">
          <strong>1.</strong>입점신청
        </div>
        <div class="S5-chart-line"></div>
        <div class="S5-chart-cont">
          <strong>2.</strong>입점심사
        </div>
        <div class="S5-chart-line"></div>
        <div class="S5-chart-cont">
          <strong>3.</strong>채널생성
        </div>
        <div class="S5-chart-line"></div>
        <div class="S5-chart-cont">
          <strong>4.</strong>서비스이용
        </div>
      </div>
      <div class="S5-notice">
        <ul>
          <li>입점신청후 3-4영업일 이내로 당담자가 연락드립니다.</li>
          <li>입점심사를 통과한 업체에 한해 입점할 수 있습니다.</li>
          <li>고객센터 상담은 평일 업무시간에 가능합니다.</li>
        </ul>
      </div>
      <div class="S5-btn">
        <span>준비중입니다.</span>
        <!-- <router-link to="/joinus" class="S5-btn-name">입점신청</router-link> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Slide5"
};
</script>
<style lang="scss" scoped>
.Side5 {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f5f0e7;

  .S5-inner {
    width: 1400px;
    height: 100%;
    padding: 100px 0px 100px 0px;
    box-sizing: border-box;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .S5-title {
      font-size: 36px;
      font-weight: 900;
      color: #272727;
      text-align: center;
    }

    .S5-chart {
      width: 100%;
      margin-top: 100px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .S5-chart-cont {
        width: 260px;
        height: 260px;
        border-radius: 130px;
        border: 1px solid #b8b0a1;
        text-align: center;
        line-height: 260px;
        font-size: 24px;
        color: #7e796f;
      }

      .S5-chart-line {
        width: 50px;
        height: 1px;
        background-color: #b8b0a1;
      }
    }

    .S5-notice {
      width: 100%;
      margin-top: 60px;
      padding-top: 5px;
      border-top: 1px solid #b8b0a1;
      margin-bottom: 50px;

      li {
        font-size: 20px;
        line-height: 34px;
        color: #7e796f;
      }
    }

    .S5-btn {
      // width: 240px;
      // height: 50px;
      // border-radius: 25px;
      // text-align: center;
      // line-height: 50px;
      // border: 1px solid #b8b0a1;
      // position: relative;
      // cursor: pointer;

      .S5-btn-name {
        font-size: 18px;
        padding: 20px 80px 20px 80px;
        border: solid 1px #b8b0a1;
        color: #b8b0a1;
        text-decoration: none;

        &:hover {
          background-color: #b8b0a1;
          color: #ffffff;
          font-weight: 700;
        }
      }
    }
  }
}
</style>